import React from "react";

function Verified() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="#00AE4E"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.32904 0.893984C8.64507 0.0478575 7.35505 0.0478575 6.67108 0.893983C6.24611 1.4197 5.55119 1.64549 4.89838 1.46997C3.84769 1.18747 2.80405 1.94572 2.74804 3.03228C2.71325 3.70738 2.28376 4.29851 1.65246 4.54022C0.636384 4.92925 0.237748 6.15613 0.831102 7.0681C1.19976 7.63472 1.19976 8.3654 0.831102 8.93202C0.237748 9.84399 0.636384 11.0709 1.65246 11.4599C2.28376 11.7016 2.71325 12.2927 2.74804 12.9678C2.80405 14.0544 3.84769 14.8127 4.89838 14.5302C5.55119 14.3546 6.24611 14.5804 6.67108 15.1061C7.35505 15.9523 8.64507 15.9523 9.32904 15.1061C9.75401 14.5804 10.4489 14.3546 11.1017 14.5302C12.1524 14.8127 13.1961 14.0544 13.2521 12.9678C13.2869 12.2927 13.7164 11.7016 14.3477 11.4599C15.3637 11.0709 15.7624 9.84399 15.169 8.93202C14.8004 8.3654 14.8004 7.63472 15.169 7.0681C15.7624 6.15613 15.3637 4.92925 14.3477 4.54022C13.7164 4.29851 13.2869 3.70738 13.2521 3.03228C13.1961 1.94572 12.1524 1.18747 11.1017 1.46997C10.4489 1.64549 9.75401 1.4197 9.32904 0.893984ZM12.8007 6.0717L11.533 4.59723L6.64842 8.79563L5.1529 6.89649L3.625 8.0992L6.37654 11.5947L12.8007 6.0717Z"
        fill="#00AE4E"
      />
    </svg>
  );
}

export default Verified;
